import { Vehicle, VehicleAlgoliaRecord } from "@/types";

export const generateVehicleImageAlt = (
    vehicle: Vehicle | VehicleAlgoliaRecord,
    index?: number,
) => {
    let year = "";
    try {
        if (vehicle.registration_at) {
            year = vehicle.registration_at.split("-")[0];
        }
    } catch (error) {}
    // display_name2 existe toujours
    const base = `${vehicle.display_name2} - ${year} - Joinsteer`;
    return index !== undefined ? `${base} - #${index + 1}` : base;
};

export const isLocalPhoto = (
    vehicle: Vehicle | VehicleAlgoliaRecord,
    photo: string,
) => {
    if ("local_photos_url" in vehicle) {
        return vehicle.local_photos_url?.includes(photo);
    }
    return vehicle.local_photos?.includes(photo);
};
